import { Button, Link, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import moment from 'moment';
import { TrialResponse } from "../../interfaces/Trials/TrialsResponse";
import CallButton from "../Common/CallButton/CallButton";
import { UserType } from "../../enums/common";
import CommonListTable, { CommonListColumn } from "../Common/CommonListTable";

interface InputProps {
    data: Array<TrialResponse>;
    page?: number;
    rowsPerPage?: number;
    total?: number;
    onPageChange?: (page: number) => void;
    onRowsPerPageChange?: (rows: number) => void;
}

const COLUMNS: CommonListColumn<any>[] = [
    { label: 'Id', field: 'id' },
    { label: 'Cook Name', render: (row) => row?.cookName || '---' },
    { label: 'CX Name', render: (row) => row?.customerName },
    {
        label: 'CX Mobile',
        stopRowClick: true,
        render: (row) => <CallButton toPhoneNumber={row?.customerPhoneNumber} userType={UserType.CUSTOMER} />,
    },
    { label: 'Status', field: 'status' },
    { label: 'Subscription Price', field: 'totalPrice' },
    {
        label: 'House',
        render: (row) => (
            <Link href={`/#/Houses/${row?.houseId}/show`}>{row?.houseId}</Link>
        ),
    },
    {
        label: 'Address',
        minWidth: 200,
        render: (row) => [
            row?.house?.locality || '',
            row?.house?.sector || '',
            row?.house?.address || '',
            row?.house?.city || ''
        ].filter((e) => e !== '').join(', '),
    },
    {
        label: 'Date',
        nowrap: true,
        render: (row) => row?.date ? moment(row?.date).format("DD MMM YYYY") : '',
    },
    { label: 'Time', field: 'time' },
    {
        label: 'PR',
        render: (row) => row?.prId ? (
            <Link href={`/#/PermanentReplacement/${row.prId}/show`}>{row.prId}</Link>
        ) : null,
    },
    {
        label: 'Meal Mapping',
        render: (row) => row.mealMapping?.length !== 0 ? (
            <Table size="small" sx={{ '&:last-child td, &:last-child th': { border: 1 } }}>
                <TableHead>
                    <TableRow>
                        <TableCell>Slot</TableCell>
                        <TableCell>Time</TableCell>
                        <TableCell>Buffer</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {row.mealMapping.map((meal: { slot: string; time: string; bufferMinutes: number }) => (
                        <TableRow key={String(meal?.slot)}>
                            <TableCell component="th" scope="row">{meal?.slot}</TableCell>
                            <TableCell sx={{ minWidth: '70px' }}>{meal?.time}</TableCell>
                            <TableCell>{meal?.bufferMinutes}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        ) : '---',
    },
    { label: 'Trial Owner Name', render: (row) => row?.trialOwnerName },
    { label: 'Trial Owner Email', render: (row) => row?.trialOwnerEmail },
    { label: 'Customer Feedback', render: (row) => row?.customerFeedback || '---' },
    { label: 'Cancellation Reason', render: (row) => row?.cancellationReason || '---' },
    { label: 'Cancellation SubReason', render: (row) => row?.cancellationSubReason || '---' },
    { label: 'Reschedule Reason', render: (row) => row?.rescheduleReason || '---' },
    { label: 'Reschedule SubReason', render: (row) => row?.rescheduleSubReason || '---' },
    { label: 'Cook Rejection Reason', render: (row) => row?.cookRejectionReason || '---' },
    {
        label: '',
        stopRowClick: true,
        render: (row) => (
            <Link href={`/#/Trials/${row.id}/show`}>
                <Button variant="contained" color="primary">Show</Button>
            </Link>
        ),
    },
];

const TrailsListForModule = (props: InputProps) => {
    return (
        <CommonListTable
            columns={COLUMNS}
            data={props.data}
            loading={false}
            page={props.page}
            rowsPerPage={props.rowsPerPage}
            total={props.total}
            onPageChange={props.onPageChange}
            onRowsPerPageChange={props.onRowsPerPageChange}
            emptyText="No Trials Found"
        />
    );
};

export default TrailsListForModule;
